import { useRef } from 'react';

const row1 = ['Workday', 'Greenhouse', 'Lever', 'iCIMS', 'SmartRecruiters', 'Workable', 'Taleo', 'Rozee.pk'];
const row2 = ['Naukri.com', 'BambooHR', 'JazzHR', 'Jobvite', 'ADP Workforce', 'Oracle HCM', 'SAP SuccessFactors', 'Bullhorn'];
const row3 = ['Recruitee', 'Pinpoint', 'Ashby', 'Rippling', 'Personio', 'Zoho Recruit', 'Breezy HR', '+ Generic (any form)'];

function MarqueeRow({ items, reverse = false }: { items: string[]; reverse?: boolean }) {
  const doubled = [...items, ...items];
  return (
    <div className="relative flex overflow-hidden w-full">
      <div
        className={`flex gap-3 ${reverse ? 'animate-marquee-reverse' : 'animate-marquee'}`}
        style={{ width: 'max-content' }}
      >
        {doubled.map((platform, index) => (
          <div
            key={index}
            className="h-11 px-6 bg-[#141828] border border-[#2D3148] rounded-full flex items-center justify-center hover:border-[#6366F1] transition-colors duration-200 cursor-pointer flex-shrink-0"
          >
            <span className="text-[#F8FAFC] text-sm font-medium whitespace-nowrap">{platform}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ATSAutofill() {
  return (
    <section id="ats-autofill" className="py-[120px] bg-gray-50 dark:bg-[#060A14] relative overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#6366F1]/10 blur-[120px]"></div>

      <div className="relative max-w-[1280px] mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-extrabold text-gray-900 dark:text-white mb-6 leading-tight">
            Autofill 9+ ATS Platforms.<br />
            Apply in seconds, not minutes.
          </h2>
          <p className="text-gray-500 dark:text-[#94A3B8] text-lg max-w-[720px] mx-auto leading-relaxed">
            Most job seekers spend 20–30 minutes manually filling each ATS form.
            JobOS detects the ATS automatically and fills every field — name, address,
            phone, work history, education, skills, LinkedIn URL, portfolio — with your
            saved profile data. In one click.
          </p>
        </div>

        {/* Animated Marquee Rows */}
        <div className="flex flex-col gap-3 mb-16 overflow-hidden">
          {/* Fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-50 dark:from-[#060A14] to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-50 dark:from-[#060A14] to-transparent z-10 pointer-events-none"></div>
          <MarqueeRow items={row1} reverse={false} />
          <MarqueeRow items={row2} reverse={true} />
          <MarqueeRow items={row3} reverse={false} />
        </div>

        {/* Stat Callout */}
        <div className="text-center">
          <div className="inline-block px-8 py-4 bg-white dark:bg-[#141828]/50 border border-indigo-200 dark:border-[#6366F1]/30 rounded-2xl">
            <p className="text-[#6366F1] text-3xl font-extrabold">
              From 25 minutes → 45 seconds per application
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
